import { useState, useEffect } from "react";
import { Routes, Route, HashRouter } from "react-router-dom";
// MUST USE V6

import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Contact } from "./components/contact";
import { Services } from "./components/services";

import { Testimonials } from "./components/testimonials";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
// fontawesome
import "@fortawesome/fontawesome-free/css/all.min.css";

// bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <HashRouter>
      <Navigation />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header data={landingPageData.Header} />
              <Services data={landingPageData.Services} />
              <Testimonials data={landingPageData.Testimonials} />
              <Contact data={landingPageData.Contact} />
            </>
          }
        />
      </Routes>
    </HashRouter>
  );
};

export default App;
